import { render, staticRenderFns } from "./DashboardDossierGestion.vue?vue&type=template&id=0dec87c6"
import script from "./DashboardDossierGestion.vue?vue&type=script&lang=js"
export * from "./DashboardDossierGestion.vue?vue&type=script&lang=js"
import style0 from "./DashboardDossierGestion.vue?vue&type=style&index=0&id=0dec87c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports